import {FC, useMemo} from 'react'

import { User } from '../../modules/core/users'
import { isValidString } from '../helpers'
import clsx from 'clsx';

type Props = {
  state_val?: string
  assigned_to?: User
  className?: string
  title?: string
}

const ApplicationStateCell: FC<Props> = ({state_val, assigned_to, className, title}) => {

  const { badge_color, badge_style } = useMemo(() => {
    let _color = '';
    let _style = {};

    let state = state_val ? state_val.replace(/ \(([0-9]+)\)$/, '') : '';

    /*
    2023.06.06
    Colors for state
    Completed/Terminated/Failed – Grey
    Issue – RED
    Pending CM/ PM – Yellow / f0ff00
    Pending Inspector – Orange / ff7e0c
    Pending Admin - Green
    */

    if (state?.match(/(Completed|Failed|Terminated)/i)) {
      _color = 'badge-secondary';
    } else if (state?.match(/(issue|invalid|pending re-component)/i)) {
      _color = 'badge-danger';
    } else if (state?.match(/(admin)/i)) {
      _color = 'badge-success';
    } else if (state?.match(/(confirmation)/i)) {
      Object.assign(_style, { backgroundColor: '#ADFF2F', color: '#333'});
    } else if (state?.match(/(termina)/i)) {
      Object.assign(_style, { backgroundColor: '#fb2c36', color: '#FFF'});
    } else if (state?.match(/(rejected)/i)) {
      Object.assign(_style, { backgroundColor: '#FF4500', color: '#FFF'});
    } else if (state?.match(/(inspection process)/i)) {
      Object.assign(_style, { backgroundColor: '#fee08b', color: '#333'});
    } else if (state?.match(/(inspector reviewer)/i)) {
      Object.assign(_style, { backgroundColor: '#fc8d62', color: '#333'});
    } else if (state?.match(/(inspector|inspection)/i)) {
      Object.assign(_style, { backgroundColor: '#40E0D0', color: '#333'});
    } else if (state?.match(/(program manager|committee)/i)) {
      Object.assign(_style, { backgroundColor: '#00BFFF', color: '#333'});
    } else if (state?.match(/^draft$/i)) {
      _color = 'badge-light';
    } else if (state?.match(/(valid)/i)) {
      _color = 'badge-primary';
    } else {
      _color = 'badge-info';
    }

    return { badge_color : _color, badge_style : _style}
  }, [state_val])

  return (
  <div
    className={clsx(
      `badge ${badge_color} fw-bolder py-2 px-3 justify-content-center mw-225px text-wrap`,
      {[`${className}`] : className && isValidString(className)}
    )}
    style={badge_style}
    title={assigned_to ? `Assigned to : ${assigned_to.name}` : title}
  >
    {state_val}
  </div>
  )
}

export {ApplicationStateCell}
